import { IconButton } from '@material-ui/core';
import styled, { css, keyframes } from 'styled-components';

const enterCharacter = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(4rem) scale(.96);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
`;

const enterBubble = keyframes`
  from {
    opacity: 0;
    transform: translateY(1.4rem) scale(.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const pulse = keyframes`
  0% {
    opacity: .9;
    transform: scale(.9);
  }
  75%, 100% {
    opacity: 0;
    transform: scale(1.65);
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1300;
  pointer-events: none;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      90deg,
      rgba(15, 27, 61, 0.08),
      rgba(15, 27, 61, 0) 68%
    );
  }
`;

export const Character = styled.img`
  position: fixed;
  z-index: 1;
  left: 50%;
  bottom: 0;
  width: clamp(26rem, 32vw, 50rem);
  max-height: calc(100vh - 7rem);
  object-fit: contain;
  object-position: bottom;
  transform: translateX(-50%);
  filter: drop-shadow(0 1.8rem 3rem rgba(15, 27, 61, 0.3));
  animation: ${enterCharacter} 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;

  @media (max-width: 720px) {
    left: 50%;
    width: clamp(18rem, 52vw, 28rem);
    max-height: 43vh;
    transform: translateX(-50%);
    animation: none;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const SpeechBubble = styled.section`
  position: fixed;
  z-index: 3;
  pointer-events: auto;
  left: clamp(28rem, 35vw, 53rem);
  bottom: clamp(7rem, 24vh, 24rem);
  width: min(42rem, calc(100vw - 4rem));
  padding: 2.4rem 2.6rem 2rem;
  color: #fff;
  background: linear-gradient(180deg, #16224f, #0f1b3d);
  border-radius: 2rem;
  box-shadow: 0 2rem 4.5rem rgba(15, 27, 61, 0.35);
  animation: ${enterBubble} 0.45s cubic-bezier(0.22, 1, 0.36, 1) 0.12s both;

  ${({ pointing }) =>
    pointing &&
    css`
      left: auto;
      bottom: auto;
    `}

  @media (max-width: 720px) {
    top: auto !important;
    right: 1.2rem !important;
    bottom: calc(43vh + 1.6rem) !important;
    left: 1.2rem !important;
    width: auto;
    padding: 2rem 2rem 1.6rem;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const CloseButton = styled(IconButton)`
  && {
    position: absolute;
    top: 0.7rem;
    right: 0.7rem;
    color: rgba(255, 255, 255, 0.82);
  }
`;

export const Title = styled.h2`
  margin: 0 3rem 0.8rem 0;
  font-size: clamp(1.8rem, 2vw, 2.2rem);
  line-height: 1.25;

  strong {
    color: #ff8a3d;
  }
`;

export const Message = styled.p`
  margin: 0;
  font-size: clamp(1.35rem, 1.4vw, 1.6rem);
  line-height: 1.55;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.8rem;
  margin-top: 1.8rem;

  button:first-child:not(:last-child) {
    color: rgba(255, 255, 255, 0.82);
  }
`;

export const TargetHighlight = styled.span`
  position: fixed;
  z-index: 2;
  pointer-events: none;
  border: 0.2rem solid #ff8a3d;
  border-radius: 50%;
  box-shadow: 0 0 0 0.5rem rgba(255, 138, 61, 0.28),
    0 0 2.2rem rgba(255, 138, 61, 0.8);

  &::after {
    content: '';
    position: absolute;
    inset: -0.8rem;
    border: 0.2rem solid #ff8a3d;
    border-radius: 50%;
    animation: ${pulse} 1.4s ease-out infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
    }
  }
`;
